<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4.125 11.25C2.26104 11.25 0.75 9.73896 0.75 7.875C0.75 6.11732 2.09363 4.67347 3.80981 4.51453C4.16086 2.3791 6.01518 0.75 8.25 0.75C10.4848 0.75 12.3391 2.3791 12.6902 4.51453C14.4064 4.67347 15.75 6.11732 15.75 7.875C15.75 9.73896 14.239 11.25 12.375 11.25C9.08262 11.25 7.00748 11.25 4.125 11.25Z"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
